import { memo } from 'react';

import { BuilderTableColumn, BuilderTableRow } from '../../../../types.js';
import FormattedField from '../FormattedField/FormattedField.jsx';

export type Props = {
  value: string | number | null;
  column: BuilderTableColumn;
  row: BuilderTableRow;
  cellColor: string;
};

const PercentField = memo(({ value, column, row, cellColor }: Props) => {
  const { scale } = row.original;

  const isEmptyValueHidden =
    !Number(value) && !!column.hideEmptyValueForReadOnlyRowLevel;

  return (
    <FormattedField
      scale={scale}
      value={value}
      decimalLimit={column.decimals}
      isEmptyValueHidden={isEmptyValueHidden}
      color={cellColor}
      variant="percent"
    />
  );
});
export default PercentField;
